import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import Select, { components } from 'react-select';
import {COMMON_FORM_STAGE, CREATE_FORM_STAGE, identityOptions} from '../../Config/appConfig';
import {Option} from '../../Config/dataModel';
import util from '../../Util/util';
import IdentityTextField from './IdentityTextField';
import Translator from '../Translator/Translator';
import {reactSelectStyles} from '../constants';
import '../../style/identityInput.css';

interface IdentityInputProps {
    stage?: string,
    identity: Option,
    identityNo: string,
    checksum: string,
    changeIdentity?: (identity: Option) => void,
    changeIdentityNo?: (identityNo: string) => void,
    changeChecksum?: (checksum: string) => void
}

class IdentityInput extends React.Component <IdentityInputProps, {}> {
    public constructor(props: IdentityInputProps) {
        super(props);
        this.changeIdentityNo = this.changeIdentityNo.bind(this);
        this.changeChecksum = this.changeChecksum.bind(this);
    }

    public changeIdentityNo(event: React.ChangeEvent<HTMLInputElement>) {
        event.preventDefault();
        let identityNo = event.target.value;
        if (util.isAlphanumeric(identityNo)) {
            if (this.props.identity.value === identityOptions[0].value) {
                identityNo = identityNo.toUpperCase().slice(0, 8);
            }
            this.props.changeIdentityNo(identityNo);
        }
    }

    public changeChecksum(event: React.ChangeEvent<HTMLInputElement>) {
        event.preventDefault();
        let checksum = event.target.value;
        if (util.isAlphanumeric(checksum)) {
            this.props.changeChecksum(checksum.toUpperCase().slice(0, 1));
        }
    }

    public render() {
        let identityTextFieldExtraProps = {};
        if (this.props.stage) {
            identityTextFieldExtraProps = {...identityTextFieldExtraProps, ...{stage: this.props.stage}};
        }
        if (this.props.changeIdentityNo) {
            identityTextFieldExtraProps = {...identityTextFieldExtraProps, ...{changeIdentityNo: this.changeIdentityNo}};
        }
        if (this.props.changeChecksum) {
            identityTextFieldExtraProps = {...identityTextFieldExtraProps, ...{changeChecksum: this.changeChecksum}};
        }

        let selectExtraProps = {};
        if (this.props.changeIdentity) {
            selectExtraProps = {...selectExtraProps, ...{onChange: (identity) => identity && this.props.changeIdentity(identity)}};
        }

        return (
            <div className="cmInput2Cols">
                <Grid className="cmInput2ColsLeft" item xs={6}>
                    <label className="cmInputLabel">
                        <Translator path="enquiry.form.labels.idType">Identity Number</Translator>
                    </label>
                    <Select
                        styles={reactSelectStyles}
                        components={{
                            Option: ({ children, value, ...props}) => (
                                <components.Option {...props}>
                                    <Translator path={`enquiry.form.idType.${value.toLowerCase()}`}>{children}</Translator>
                                </components.Option>
                            ), ValueContainer: ({ children, getValue, ...props }) => (
                                <components.ValueContainer {...props}>
                                    <Translator path={`enquiry.form.idType.${getValue()[0].value.toLowerCase()}`}>{children}</Translator>
                                </components.ValueContainer>
                            )
                        }}
                        className="react-select__container"
                        classNamePrefix="react-select"
                        options={identityOptions}
                        value={this.props.stage === COMMON_FORM_STAGE.PRINT ? {
                            value: '',
                            label: 'Not Accessible'
                        } : this.props.identity}
                        clearable={false}
                        isDisabled={!(this.props.stage === CREATE_FORM_STAGE.CREATE || this.props.stage === COMMON_FORM_STAGE.PROCEED)}
                        {...selectExtraProps}/>
                </Grid>
                <Grid item xs={6}>
                    <IdentityTextField
                        identity={this.props.identity}
                        identityNo={this.props.identityNo}
                        checksum={this.props.checksum}
                        {...identityTextFieldExtraProps}/>
                </Grid>
            </div>
        );
    }
}

export default IdentityInput;



// WEBPACK FOOTER //
// ./src/Components/Custom/IdentityInput.tsx